import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import getPermissionsFromTree from './getPermissionsFromTree.helper';

import { canEditPriorPeriodDataSelector, isInCurrentPeriodSelector } from '../store/selectors';

const selectPermissionsFromTree = createSelector(
  ({ user }) => user.user.permissions,
  ({ permissionPath }) => permissionPath,
  getPermissionsFromTree
);

const withPermissions = WrappedComponent => (
  class WithPermissionsWrapper extends PureComponent {
    static propTypes = {
      permissionsFromTree: PropTypes.shape({
        view: PropTypes.bool.isRequired,
        modify: PropTypes.bool.isRequired,
      }).isRequired,
      canEditPriorPeriodData: PropTypes.bool.isRequired,
      isInCurrentPeriod: PropTypes.bool.isRequired,
    };

    render() {
      const { permissionsFromTree, canEditPriorPeriodData, isInCurrentPeriod, ...props } = this.props;

      const { view: canView, modify: canModify, ...additional } = permissionsFromTree;

      const currentPeriodPermission = isInCurrentPeriod || (!isInCurrentPeriod && canEditPriorPeriodData);

      const canModifyInSelectedPeriod = canModify && currentPeriodPermission;

      const additionalPermissions = Object.keys(additional).reduce((permissionsObj, permission) => {
        permissionsObj[permission] = {
          permission: additional[permission],
          permissionInSelectedPeriod: additional[permission] && currentPeriodPermission,
        };
        return permissionsObj;
      }, {});

      return (
        <WrappedComponent
          canView={canView}
          canModify={canModify}
          canModifyInSelectedPeriod={canModifyInSelectedPeriod}
          additionalPermissions={additionalPermissions}
          {...props}
        />
      );
    }
  }
);

export default permissionPath => compose(
  connect(state => ({
    permissionsFromTree: selectPermissionsFromTree({ ...state, permissionPath }),
    canEditPriorPeriodData: canEditPriorPeriodDataSelector(state),
    isInCurrentPeriod: isInCurrentPeriodSelector(state),
  })),
  withPermissions
);
